<template>
  <section>
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center leading">
        <b-col cols="12" sm="10" md="9" xl="7">
          <div class="showLeader">
            <div class="leader" v-for="item in leaderData" :key="item.id">
              <div>
                <h3>
                  {{ item.name }}
                  <!-- <span></span> -->
                </h3>
                <p>{{ item.job }}</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        img:require("@/assets/images/connect_banner.png"),
        title:'中心领导',
        subTitle:'Leaders'
      },
      leaderData: [
        {
          id: "1",
          name: "张西武",
          job: "党委书记 、 副主任",
        },
        {
          id: "2",
          name: "孙立华",
          job: "党委委员 、 副主任",
        },
        {
          id: "3",
          name: "薛煜",
          job: "党委副书记 、 纪委书记",
        },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/leading.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .leader {
    width: 100%;
    height: 60%;
    padding: 25px 0;
    > div {
      flex-direction: column;
      h3 {
        font-size: 24px;
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 10px;
      }
      p {
        font-size: 16px;
        width: 100%;
        flex-direction: column;
      }
    }
  }
  .leader:nth-child(3n) {
    margin-right: 0px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .leader {
    width: 100%;
    > div h3 {
      font-size: 24px;
    }
    > div p {
      font-size: 16px;
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .leader {
    width: 100%;
    > div h3 {
      font-size: 26px;
    }
    > div p {
      font-size: 18px;
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .leader {
    width: 100%;
    > div h3 {
      font-size: 30px;
    }
    > div p {
      font-size: 20px;
    }
  }
}
@media (min-width: 1200px) {
}
</style>